import { gql } from '@apollo/client';

export const ADD_WARRANTY_INFO = gql`
  mutation addWarrantyInfo(
    $email: String!
    $firstname: String!
    $lastname: String!
    $phone: String!
    $gender: Int!
    $birthday: String!
    $increment_id: String!
    $website: Int!
    $website_other: String
    $purchased_item_category: String!
    $use: String!
    $platform: String!
    $platform_other: String
    $tags: [String]
    $country_id: String
  ) {
    addWarrantyInfo(
      input: {
        email: $email
        firstname: $firstname
        lastname: $lastname
        phone: $phone
        gender: $gender
        birthday: $birthday
        increment_id: $increment_id
        website: $website
        website_other: $website_other
        purchased_item_category: $purchased_item_category
        use: $use
        platform: $platform
        platform_other: $platform_other
        tags: $tags
        country_id: $country_id
      }
    ) {
      code
      message
      content
    }
  }
`;

export default {
  addWarrantyInfoMutation: ADD_WARRANTY_INFO,
};
